import { Link } from 'react-router-dom';
import JsonLd from '@/components/base/JsonLd';

const VALUES = [
  {
    icon: 'ri-focus-3-line',
    title: '内容专注',
    desc: '我们深耕恋爱、言情与少女漫画赛道，只做一类内容，做到极致，让你每一次打开都有想看的东西。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '更新及时',
    desc: '热门作品更新第一时间同步，追更进度清晰，不让你错过任何一章心动剧情。',
  },
  {
    icon: 'ri-book-open-line',
    title: '免费开放',
    desc: '大量免费章节开放试读，降低入门门槛，好作品先尝后追，选择更从容。',
  },
  {
    icon: 'ri-heart-3-line',
    title: '尊重创作',
    desc: '我们尊重每一位创作者，坚持内容导向，支持正版，倡导健康有爱的阅读环境。',
  },
];

const PRINCIPLES = [
  '坚持优质内容优先，宁缺毋滥',
  '分类清晰，检索便捷，拒绝信息过载',
  '尊重版权，支持正版漫画创作',
  '聆听读者反馈，持续打磨阅读体验',
];

const TESTIMONIALS = [
  {
    name: '桃子同学',
    text: '从首页搜到《桃花醉》就停不下来了，古风恋爱分类真的全，追更进度一目了然，更新也特别快。',
  },
  {
    name: '奶茶不加糖',
    text: '最喜欢甜宠分类，每天蹲更新。站内搜索很快，输入名字就能直接找到，免费章节也多，太方便了。',
  },
  {
    name: '云朵收藏家',
    text: '分类做得很细，现代言情、校园青春都分开了，不会乱。排行榜也靠谱，跟着榜单追没有踩雷过。',
  },
];

export default function About() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于桃花漫画网',
    description: '桃花漫画网专注于恋爱言情漫画在线阅读，提供古风恋爱、现代言情、甜宠少女漫画分类与实时更新服务。',
    url: 'https://cartonplay.github.io/about',
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: '桃花漫画网', url: 'https://cartonplay.github.io/' },
  };

  return (
    <>
      <JsonLd data={schema} />

      {/* Hero */}
      <section className="relative overflow-hidden bg-background-100">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-14 text-center md:px-6 md:py-20">
          <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-1.5 text-xs font-medium text-primary-600">
            <i className="ri-flower-fill text-primary-500" />
            认识我们
          </span>
          <h1 className="font-display text-3xl font-bold text-foreground-900 md:text-5xl">
            关于桃花漫画网
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">
            桃花漫画网是一群热爱漫画的读者共同搭建的恋爱漫画在线阅读平台。我们希望用清晰、便捷、免费的方式，让每一位喜欢言情漫画的你，都能轻松找到、自由追更、快乐阅读。
          </p>
        </div>
      </section>

      {/* Positioning */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20warm%20illustration%20of%20a%20girl%20relaxing%20reading%20romance%20manga%20on%20a%20couch%20surrounded%20by%20peach%20blossom%20petals%2C%20soft%20warm%20cream%20and%20pink%20palette%2C%20cozy%20home%20atmosphere%20with%20warm%20lamp%20light%20and%20steaming%20tea%2C%20gentle%20pastel%20anime%20style%2C%20peaceful%20comfortable%20reading%20moment%2C%20warm%20inviting%20artistic%20scene&width=1200&height=900&seq=about-reading&orientation=portrait"
              alt="在桃花漫画网惬意阅读恋爱漫画"
              title="桃花漫画网在线阅读场景"
              className="aspect-[4/3] w-full object-cover object-top"
            />
          </div>
          <div>
            <h2 className="font-display text-2xl font-bold text-foreground-900 md:text-3xl">
              我们是谁，为何而存在
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              恋爱漫画的世界很大，从古风权谋到现代都市，从甜宠少女到校园青春，内容浩如烟海。但对普通读者来说，找到"好看、更新快、方便读"的作品并不容易。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              桃花漫画网想解决的，正是这个问题。我们以恋爱言情为核心，把古风、现代言情、甜宠、校园、都市等分类整理清楚，提供实时更新与便捷搜索，让"想看的漫画"能被你一眼找到。好内容，不该被埋没。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {(
                [
                  ['500+', '收录作品'],
                  ['26', '题材分类'],
                  ['98%', '更新及时率'],
                  ['100万+', '累计阅读人次'],
                ] as [string, string][]
              ).map(([num, label]) => (
                <div key={label} className="rounded-xl bg-background-100 px-3 py-4 text-center">
                  <p className="font-display text-xl font-bold text-primary-600">{num}</p>
                  <p className="mt-1 text-xs text-foreground-500">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="font-display text-2xl font-bold text-foreground-900 md:text-3xl">
            我们的内容理念
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">
            四条朴素的原则，支撑起每一次阅读体验。
          </p>
          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-2xl bg-background-50 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${v.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-display text-lg font-bold text-foreground-800">{v.title}</h3>
                <p className="mt-2 text-sm leading-6 text-foreground-600">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Principles + Testimonials */}
      <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div className="rounded-2xl bg-background-100/70 p-6 md:p-8">
            <h3 className="font-display text-xl font-bold text-foreground-900">内容原则</h3>
            <ul className="mt-5 space-y-4">
              {PRINCIPLES.map((p) => (
                <li key={p} className="flex items-start gap-3 text-sm text-foreground-600">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-500 text-background-50">
                    <i className="ri-check-line text-[11px]" />
                  </span>
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="font-display text-xl font-bold text-foreground-900">读者怎么说</h3>
            <div className="mt-5 space-y-4">
              {TESTIMONIALS.map((t) => (
                <blockquote key={t.name} className="rounded-2xl bg-background-100/70 p-5">
                  <p className="text-sm leading-6 text-foreground-600">"{t.text}"</p>
                  <footer className="mt-3 flex items-center gap-2 text-xs text-foreground-400">
                    <i className="ri-heart-3-fill text-accent-500" />
                    {t.name}
                  </footer>
                </blockquote>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact + CTA */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Soft%20warm%20peach%20and%20pink%20pastel%20gradient%20background%20with%20floating%20cherry%20blossom%20petals%20and%20gentle%20light%20glow%2C%20dreamy%20cozy%20romance%20atmosphere%2C%20minimal%20elegant%20artistic%20illustration%2C%20calm%20inviting%20warm%20tones%20for%20a%20contact%20banner&width=1600&height=600&seq=about-cta&orientation=landscape"
            alt="桃花漫画网联系我们背景"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-foreground-950/30" />
        </div>
        <div className="relative mx-auto flex w-full max-w-5xl flex-col items-center px-4 py-16 text-center md:py-20">
          <h2 className="font-display text-2xl font-bold text-background-50 md:text-4xl">
            想和我们聊聊？欢迎随时联系
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-7 text-background-100/90">
            无论是作品推荐、问题反馈，还是合作交流，都可以通过邮箱与我们取得联系，我们会认真对待每一封来信。
          </p>
          <div className="mt-7 flex flex-col items-center gap-3 sm:flex-row">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-6 py-3 text-sm font-medium text-foreground-800">
              <i className="ri-mail-line text-primary-600" />
              hello@taohua-manga.com
            </span>
            <Link
              to="/category"
              className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              去逛逛漫画
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}